/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  $(document).ready(function() {
    
    // Switch + fade sections
    $(document).on('click', '[data-switch-fade-trigger]', function(e) {
      const $target = $(e.currentTarget);
      const $parent = $target.closest('[data-switch-fade-parent]');
      const $content = $parent.find('[data-switch-fade-content]');
      const triggerId = $target.data('switch-fade-trigger');

      $content.each((i, el) => {
        const $el = $(el);
        const contentId = $el.data('switch-fade-content');

        if ((!triggerId && contentId === 'default') || (triggerId === contentId)) {
          $el.removeClass('invisible');
        } else {
          $el.addClass('invisible');
        }
      });
    });
  });

})();
